export var DocsBlockItemVariantLayoutWidth;
(function (DocsBlockItemVariantLayoutWidth) {
    /** Column will take 1/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c1"] = "1";
    /** Column will take 2/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c2"] = "2";
    /** Column will take 3/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c3"] = "3";
    /** Column will take 4/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c4"] = "4";
    /** Column will take 5/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c5"] = "5";
    /** Column will take 6/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c6"] = "6";
    /** Column will take 7/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c7"] = "7";
    /** Column will take 8/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c8"] = "8";
    /** Column will take 9/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c9"] = "9";
    /** Column will take 10/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c10"] = "10";
    /** Column will take 11/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c11"] = "11";
    /** Column will take 12/12 of the available space */
    DocsBlockItemVariantLayoutWidth["c12"] = "12";
})(DocsBlockItemVariantLayoutWidth || (DocsBlockItemVariantLayoutWidth = {}));
